module.exports = __webpack_public_path__ + "static/media/westinchennai12.7738323b.jpg";